(function() {
    'use strict';

    angular
        .module('szallodak-accommodation', []);
})();
